export default "__VITE_ASSET__B$Il$v3n__"